import React, { useEffect, useMemo } from 'react';
import { getDetails } from 'src/models/details/selectors';
import {
  clearModuleButtons,
  setModuleButtons,
} from 'src/models/moduleButtons/slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import DetailsBody from './detailsBody';
import ProfileCard from './profileCard';
import {
  getModuleButtons,
  getReferredModuleActions,
  updateBreadcrumbs,
} from './queries';
import styles from './index.module.scss';

function Details360(props) {
  const { entityId } = props;
  const details = useAppSelector((state) => getDetails(state, entityId));
  const dispatch = useAppDispatch();

  const referredActions = useMemo(() => {
    const actions = getReferredModuleActions(details, props, dispatch);
    return actions;
  }, [details, dispatch, props]);

  useEffect(() => {
    const moduleButtons = getModuleButtons(referredActions);
    if (moduleButtons.length) {
      dispatch(setModuleButtons(moduleButtons));
    }

    return () => {
      dispatch(clearModuleButtons());
    };
  }, [details, dispatch, referredActions]);

  useEffect(() => {
    if (details?.inputsMap) {
      updateBreadcrumbs(dispatch, props, details?.inputsMap);
    }
  }, [details?.inputsMap, dispatch, props]);

  return (
    <div className={styles.detailsWrapper}>
      <div className={styles.detailsWrapper__detailsGutter}>
        <ProfileCard {...props} />
        <DetailsBody {...props} />
      </div>
    </div>
  );
}

export default Details360;
